import MobileNavWrapper from "components/MobileNavWrapper/MobileNavWrapper";

import { MobileRouterOutlet } from "./MobileRouterOutlet";
import { mobileNavItems } from "./routeData";

export function MobileStack() {
  return (
    <MobileNavWrapper navItems={mobileNavItems}>
      <MobileRouterOutlet />
    </MobileNavWrapper>
  );
}
